import React from 'react';


export const useToggle = (defaultValue = false) => {
  const [ value, setValue ] = React.useState(defaultValue);

  const open = React.useCallback(() => setValue(true), []);
  const close = React.useCallback(() => setValue(false), []);
  const toggle = React.useCallback(() => setValue(v => !v), []);
  const result = React.useMemo(() => {
    return [ value, open, close, toggle ] as const;
  }, [ value, open, close, toggle ]);

  return result;
};

export const useToggleObject = (defaultValue = false) => {
  const [ value, open, close, toggle ] = useToggle(defaultValue);

  return React.useMemo(() => ({ value, open, close, toggle }), [ value, open, close, toggle ]);
};
